export const notifySubscriber = (
  subscriber,
  subscription,
  state,
  prevState,
  predicate,
  force = false
) => {
  const notification = predicate(state, prevState, subscription, force);
  if (notification) {
    subscriber(notification);
  }
};

export const notify = ({ entries }, state, prevState, predicate, force) => {
  Object.keys(entries).forEach((key) => {
    const entry = entries[Number(key)];
    const { notified, subscriber, subscription } = entry;
    if (
      notifySubscriber(
        subscriber,
        subscription,
        state,
        prevState,
        predicate,
        force || !notified
      )
    ) {
      entry.notified = true;
    }
  });
};
